import { render, staticRenderFns } from "./godown.vue?vue&type=template&id=04da641e&"
import script from "./godown.vue?vue&type=script&lang=js&"
export * from "./godown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports